module.exports = "<button (click)=\"showSubscriptionInfoModal()\"\n        class=\"btn btn-rounded btn-default\">Subscription Info\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/admin/subscription-info/subscription-info-btn.html
// module id = ./web/modern/components/admin/subscription-info/subscription-info-btn.html
// module chunks = 0